import { animations } from '@/assets/animations';
import { images } from '@/assets/images';
import { sounds } from '@/assets/sounds';

const assets = {
  fonts: {
    fontFamily: 'Shabnam',
    fontFamilyBold: 'ShabnamBold',
  },
  animations,
  images,
  sounds,
};

export function useAssets() {
  return assets;
}
